export default __webpack_public_path__ + "static/media/Ð¡Ð½Ð¸Ð¼Ð¾Ðº ÑÐºÑÐ°Ð½Ð° 2024-05-16 140020.f96f5776.jpg";